import React from "react";

export default () => (
  <svg
    fill="none"
    height="28"
    viewBox="0 0 28 28"
    width="28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="14" cy="14" r="11" stroke="currentColor" strokeWidth="2" />
    <path
      d="M14 7C16.2133 7 18 8.56333 18 10.5C18 12.4367 16.2133 14 14 14C11.7867 14 10 12.4367 10 10.5C10 8.56333 11.7867 7 14 7Z"
      fill="currentColor"
    />
    <path
      d="M14 21C11.5 21 9.29 19.781 8 17.9333C8.03 16.0381 12 15 14 15C15.99 15 19.97 16.0381 20 17.9333C18.71 19.781 16.5 21 14 21Z"
      fill="currentColor"
    />
  </svg>
);
